<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003605.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 1,
          label: 'P0003605.dashboard.regul' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-orange',
        },
        {
          ref: 0,
          label: 'P0003605.dashboard.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-red',
        },
        {
          ref: 2,
          label: 'P0003605.dashboard.hiver' | translate,
          icon: 'fa-kit fa-picto-hiver',
          color: 'color-orange',
        },
      ]"
      [value]="this.actionStack!.getValue('icCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Controle,
          'icCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row align-items-center">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003605.controle.amorcage' | translate
      }}</ion-label>
    </div>
  </div>

  <div class="my-3 d-inline-block">
    <app-mode-control-simple
      [data]="
        actionStack!.getValue('icCCommandeAmorcageCloud') === 0
          ? {
              label: 'P0003605.controle.amorcage' | translate,
              icon: 'fa-kit fa-picto-playregular',
              color: 'color-medium',
            }
          : {
              label: 'P0003605.controle.stop' | translate,
              icon: 'fa-kit fa-picto-stop',
              color: 'color-red',
            }
      "
      (onTouchStart)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Controle,
          'icCCommandeAmorcageCloud',
          1
        );
        this.actionStack!.commit()
      "
      (onTouchEnd)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Controle,
          'icCCommandeAmorcageCloud',
          0
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-simple>
  </div>
</div>
